import Vue from 'vue';
import { VueEditor } from "vue2-editor";

//helper app
import './Components/Helpers/HelperComponent';

Vue.component('vue-editor', VueEditor); // <-- Asegúrate que se registre globalmente aquí
/** 
 * 
 * all component of GUD
 */
Vue.component('personal-information', require('./Components/Views/Auth/PersonalInformation').default);
Vue.component('password-change', require('./Components/Views/Auth/PasswordChange').default);
Vue.component('social-links', require('./Components/Views/Auth/SocialLinks').default);
Vue.component('login', require('./Components/Views/Auth/Login').default);
Vue.component('password-reset', require('./Components/Views/Auth/PasswordReset').default);
Vue.component('reset-password', require('./Components/Views/Auth/ResetPassword').default);
Vue.component('registration', require('./Components/Views/Auth/Registration').default);
Vue.component('user-verified', require('./Components/Views/Auth/UserVerified').default);
Vue.component('my-profile', require('./Components/Views/Auth/Profile').default);

// Settings
Vue.component('app-setting', require('./Components/Views/Settings/Index').default);
Vue.component('general-setting', require('./Components/Views/Settings/GeneralSetting').default);
Vue.component('email-setting', require('./Components/Views/Settings/EmailSetting').default);
Vue.component('sms-setting', require('./Components/Views/Settings/SmsSetting').default);
Vue.component('contract-setting', require('./Components/Views/Settings/ContractSetting').default);
Vue.component('costs-setting', require('./Components/Views/Settings/CostSettings').default);
Vue.component('google-re-captcha-setting', require('./Components/Views/Settings/GoogleRecaptchaSetting').default);
Vue.component('notification-settings', require('./Components/Views/Settings/Notification/Settings/Index').default);
Vue.component('storage-setting', require('./Components/Views/Settings/Storage/Index').default);
Vue.component('database-template', require('./Components/Views/Settings/Notification/Template/DatabaseTemplate').default);
Vue.component('mail-template', require('./Components/Views/Settings/Notification/Template/MailTemplate').default);
Vue.component('payment-method', require('./Components/Views/Settings/PaymentMethod/PaymentMethod').default);
Vue.component('payment-method-create-edit-modal', require('./Components/Views/Settings/PaymentMethod/PaymentMethodCreateEditModal').default);
Vue.component('unit-setting', require('./Components/Views/Settings/Units/index').default);
Vue.component('currency-setting', require('./Components/Views/Settings/Currency/index').default);

// User and Roles
Vue.component('user-roles', require('./Components/Views/UserRoles/Index').default);
Vue.component('group-of-users', require('./Components/Views/UserRoles/Roles/GroupOfUsers').default);

// Layouts
Vue.component('app-top-bar', require('./Components/Views/Layouts/Nabar').default);
Vue.component('app-sidebar', require('./Components/Views/Layouts/Sidebar.vue').default);

// notifications
Vue.component('all-notification', require('./Components/Views/Auth/Notification').default);

Vue.component('re-captcha', require('./Components/Views/Auth/ReCaptcha').default);
Vue.component('payment-view', require('./Components/Views/Demo/Pages/PaymentMethodView').default);

//Custom Table
Vue.component('app-custom-tables', require('./Components/Views/Settings/CustomTable/CustomTable.vue').default)
Vue.component('app-custom-table-modal', require('./Components/Views/Settings/CustomTable/CustomTableModal').default)

// Dynamic table
Vue.component('app-custom-table-dynamic', require('./Components/Views/Demo/CustomTable/DynamicPage.vue').default)


// building constuction 

Vue.component('page-building', require('./Components/Views/Settings/building.vue').default);

// formulary 
Vue.component('add-form', require('./Components/Views/Products/crud/addProductForm.vue').default)



// Products ------------------------------------------------
Vue.component('products-list', require('./Components/Views/Products/ProductsList.vue').default)
Vue.component('products-add', require('./Components/Views/Products/ProductAdd.vue').default)
Vue.component('product-categories-list', require('./Components/Views/Products/ProductCategoriesList').default)
Vue.component('product-add-modal', require('./Components/Views/Products/crud/AddProductModal.vue').default);
Vue.component('add-product-form', require('./Components/Views/Products/crud/addProductForm.vue').default)
Vue.component('product-category-add-modal', require('./Components/Views/Products/crud/AddProductCategoryModal').default);

/** 
 * 
 * all component of Customers 
 */
// tabs add customer
Vue.component('customers', require('./Components/Views/Customers/ComponentsTabs.vue').default)
Vue.component('add-customers', require('./Components/Views/Customers/AddCustom.vue').default)

// components tabs add supplier
Vue.component('customer-add', require('./Components/Views/Customers/Crud/added.vue').default)
Vue.component('customer-contacts', require('./Components/Views/Customers/Crud/contacts.vue').default)
Vue.component('customer-Address', require('./Components/Views/Customers/Crud/address.vue').default)

// customer list
Vue.component('companies-list', require('./Components/Views/Customers/index.vue').default)

// location 
Vue.component('location-list', require('./Components/Views/Location/index.vue').default)

// packers 
Vue.component('packers-list', require('./Components/Views/Packer/index.vue').default)

// brokers
Vue.component('brokers-list', require('./Components/Views/Brokers/index.vue').default)

// product_type
Vue.component('product_type-list', require('./Components/Views/ProductType/index.vue').default)

// Contract condition
Vue.component('contract_condition-list', require('./Components/Views/ContractCondition/index.vue').default)

// product_types
Vue.component('product_types-list', require('./Components/Views/ProductTypes/index.vue').default)

// upload images
Vue.component('upload_images-list', require('./Components/Views/UploadImages/index.vue').default)


// components tabs edit  C:\laragon\www\slap\resources\js\app\Components\Views\Customers\patch\added.vue
Vue.component('customer-add-edit', require('./Components/Views/Customers/patch/added.vue').default)
Vue.component('customer-contacts-edit', require('./Components/Views/Customers/patch/contacts.vue').default)
Vue.component('customer-Address-edit', require('./Components/Views/Customers/patch/address.vue').default)


// components suppliers  ----------------------------------------------------------------------------------

// suppliers list
Vue.component('suppliers-list', require('./Components/Views/Suppliers/index.vue').default)




// component TABS 
Vue.component('suppliers', require('./Components/Views/Suppliers/CompaniesComponentsTabs.vue').default)

// components tabs add supplier
Vue.component('supplier-add', require('./Components/Views/Suppliers/Crud/added.vue').default)
Vue.component('supplier-contacts', require('./Components/Views/Suppliers/Crud/contacts.vue').default)
Vue.component('supplier-Address', require('./Components/Views/Suppliers/Crud/address.vue').default)


// components tabs edit 
Vue.component('supplier-add-edit', require('./Components/Views/Suppliers/patch/added.vue').default)
Vue.component('supplier-contacts-edit', require('./Components/Views/Suppliers/patch/contacts.vue').default)
Vue.component('supplier-Address-edit', require('./Components/Views/Suppliers/patch/address.vue').default)



// subcontracts -----------------------------------------------------------------------------
Vue.component('subcontracts-list', require('./Components/Views/SubContracts/SubcontractsList.vue').default);


// contracts ---------------------------------------------------------------------------------------------
Vue.component('contracts-list', require('./Components/Views/Contracts/ContractsList.vue').default);

// Vue.component('contract-list-all', require('./Components/Views/Contracts/ContractList.vue').default)

Vue.component('contract-add', require('./Components/Views/Contracts/ContractAdd.vue').default)
Vue.component('contract-add-details', require('./Components/Views/Contracts/ContractDetails.vue').default)

// tabs 
Vue.component('form-details', require('./Components/Views/Contracts/tabs/FormDetails.vue').default)
Vue.component('form-products', require('./Components/Views/Contracts/tabs/ProductsDetails.vue').default)
Vue.component('form-suppliers', require('./Components/Views/Contracts/tabs/SuppliersDetails.vue').default)
Vue.component('form-customer', require('./Components/Views/Contracts/tabs/CustomersDetails.vue').default)
Vue.component('form-revision', require('./Components/Views/Contracts/tabs/Revision.vue').default)
Vue.component('form-documents_edit', require('./Components/Views/Contracts/tabs/ImportDocuments_edit.vue').default)

// Vue.component('form-details_edit', require('./Components/Views/Contracts/tabs_edit/FormDetails_edit.vue').default)
// Vue.component('form-products_edit', require('./Components/Views/Contracts/tabs_edit/ProductsDetails.vue').default)
// Vue.component('form-suppliers_edit', require('./Components/Views/Contracts/tabs_edit/SuppliersDetails.vue').default)
// Vue.component('form-customer_edit', require('./Components/Views/Contracts/tabs_edit/CustomersDetails.vue').default)
Vue.component('form-documents', require('./Components/Views/Contracts/tabs/ImportDocuments.vue').default)
// Vue.component('form-revision_edit', require('./Components/Views/Contracts/tabs_edit/Revision.vue').default)

// Vue.component('form-details_view', require('./Components/Views/Contracts/tabs_view/FormDetails.vue').default)
// Vue.component('form-products_view', require('./Components/Views/Contracts/tabs_view/ProductsDetails.vue').default)
// Vue.component('form-suppliers_view', require('./Components/Views/Contracts/tabs_view/SuppliersDetails.vue').default)
// Vue.component('form-customer_view', require('./Components/Views/Contracts/tabs_view/CustomersDetails.vue').default)
Vue.component('form-documents_view', require('./Components/Views/Contracts/tabs/ImportDocuments_view.vue').default)
Vue.component('form-revision_view', require('./Components/Views/Contracts/tabs/Revision_view.vue').default)

Vue.component('app-add-sub_contract', require('./Components/Views/Contracts/Modal_addSubcontract.vue').default)
Vue.component('duplicate_contract', require('./Components/Views/Contracts/ModalDuplicate.vue').default)

// subcontracts
Vue.component('form-sub_contract_detail', require('./Components/Views/SubContracts/tabs/FormDetails.vue').default)
Vue.component('form-sub_contract_suppliers', require('./Components/Views/SubContracts/tabs/FormSuppliers.vue').default)
Vue.component('form-sub_contract_customer', require('./Components/Views/SubContracts/tabs/FormCustomer.vue').default)
Vue.component('form-sub_contract_shipping', require('./Components/Views/SubContracts/tabs/FormShipping.vue').default)
Vue.component('form-sub_inventory', require('./Components/Views/SubContracts/tabs/FormInventory.vue').default)
Vue.component('form-sub_contract_schedule', require('./Components/Views/SubContracts/tabs/FormSchedule.vue').default)
Vue.component('form-sub_contract_accounting', require('./Components/Views/SubContracts/tabs/FormAccounting.vue').default)
Vue.component('form-sub_contract_forms', require('./Components/Views/SubContracts/tabs/FormForms.vue').default)
Vue.component('contract_detail', require('./Components/Views/Contracts/tabs_view_logistic_coordinator/ContractDetail_view.vue').default);
Vue.component('contract_status', require('./Components/Views/Contracts/tabs_view_logistic_coordinator/ContractStatus_view.vue').default);

// product_type
Vue.component('costing-list', require('./Components/Views/Costing/index.vue').default);